import * as en from '../en.json';
import * as settings_page from './settings_page.json';
import * as quest_widget from './quest_widget.json';
import * as status_bar from './status_bar_element.json';
import * as quest_page from './quest_page.json';
import * as bonus_buy_widget from './bonus_buy_widget.json';
import * as double_bonus_chance_widget from './double_bonus_chance_widget.json';
import * as bonus_buy_dialog from './bonus_buy_dialog.json';
import * as bonus_revive_widget from './bonus_revive_widget.json';
import * as bonus_revive_dialog from './bonus_revive_dialog.json';
import * as splash_screen_page from './splash_screen_page.json';
import * as win_highlight_popup from './win_highlight_popup.json';
import * as info_page from './info_page.json';
import * as general_elements from './general_elements.json';
import * as auto_spin from './auto_spin.json';
import * as fastplay_dialogue from './fastplay_dialogue.json';
import * as free_spin_page from './free_spin_page.json';
import * as free_spin_page_win from './free_spin_page_win.json';
import * as free_spin_status_bar from './free_spin_status_bar.json';
import * as bonus_round_dialogue from './bonus_round_dialogue.json';
import * as bonus_round_page from './bonus_round_page.json';
import * as bet_amount from './bet_amount.json';
import * as prompt from './prompt.json';
import * as reel from './reel.json';

const en_texts = {
	...settings_page,
	...quest_widget,
	...status_bar,
	...quest_page,
	...bonus_buy_widget,
	...double_bonus_chance_widget,
	...bonus_buy_dialog,
	...bonus_revive_widget,
	...bonus_revive_dialog,
	...splash_screen_page,
	...win_highlight_popup,
	...info_page,
	...general_elements,
	...auto_spin,
	...fastplay_dialogue,
	...free_spin_page,
	...free_spin_page_win,
	...free_spin_status_bar,
	...bonus_round_dialogue,
	...bonus_round_page,
	...bet_amount,
	...prompt,
	...reel,
	...en
};

export default en_texts;
